import { convertPrice } from './price'
import { addSalesTax } from './payment'

import { IRegistrationFeesInterface } from '../models/registration-fees/registrationFees.interface'
import { IRegistrationTicketInterface } from '../models/registration-tickets/registrationTicket.interface'
import { IRegistrationByDayInterface } from '../models/registrations-by-day/registrationByDay.interface'
import { IScratchedItem } from '../types/payment'

interface IGetScratchItems {
  registrationsByDay: IRegistrationByDayInterface[]
  fees: IRegistrationFeesInterface[]
  tickets: IRegistrationTicketInterface[]
  chargeSalesTax: boolean
}
export const getScratchItems = ({
  registrationsByDay,
  fees,
  tickets,
  chargeSalesTax,
}: IGetScratchItems) => {
  let scratchedRegistrations: IScratchedItem = {
    scratchedItems: [],
    scratchTotal: 0,
    scratchTotalSalesTax: 0,
  }
  let scratchedFees: IScratchedItem = {
    scratchedItems: [],
    scratchTotal: 0,
    scratchTotalSalesTax: 0,
  }
  let scratchedTickets: IScratchedItem = {
    scratchedItems: [],
    scratchTotal: 0,
    scratchTotalSalesTax: 0,
  }

  registrationsByDay
    .filter((item) => !item.isDivision)
    .forEach((item) => {
      const amountScratched =
        convertPrice(item.registrationPrice) +
        (item?.isQualify ? convertPrice(item?.qualifyFee) : 0)
      scratchedRegistrations.scratchTotal += amountScratched
      scratchedRegistrations.scratchTotalSalesTax += addSalesTax(
        item.created,
        amountScratched,
        item.includeSalesTax,
        chargeSalesTax
      )
      scratchedRegistrations.scratchedItems.push({
        docId: item.id || '',
        recipientId: item.recipientId || '',
        recipientName: item.recipientName || '',
        recipientProfilePicture: item.recipientProfilePicture || '',
        amountScratched: amountScratched / 100,
      })
    })

  fees.forEach((item) => {
    const amountScratched = convertPrice(item.feesPrice) * (item?.selectedUnitsCount || 1)
    scratchedFees.scratchTotal += amountScratched
    scratchedFees.scratchTotalSalesTax += addSalesTax(
      item.created,
      amountScratched,
      item.includeSalesTax,
      chargeSalesTax
    )
    scratchedFees.scratchedItems.push({
      docId: item.id || '',
      recipientId: item.recipientId || '',
      recipientName: item.recipientName || '',
      recipientProfilePicture: item.recipientProfilePicture || '',
      amountScratched: amountScratched / 100,
    })
  })

  tickets.forEach((item) => {
    const amountScratched = convertPrice(item.ticketPrice) * (item?.selectedUnitsCount || 1)
    scratchedTickets.scratchTotal += amountScratched
    scratchedTickets.scratchTotalSalesTax += addSalesTax(
      item.created,
      amountScratched,
      item.includeSalesTax,
      chargeSalesTax
    )
    scratchedTickets.scratchedItems.push({
      docId: item.id || '',
      recipientId: item.recipientId || '',
      recipientName: item.recipientName || '',
      recipientProfilePicture: item.recipientProfilePicture || '',
      amountScratched: amountScratched / 100,
    })
  })
  return {
    scratchedRegistrations,
    scratchedFees,
    scratchedTickets,
  }
}
